import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { AlertService } from '../../services/alert/alert.service';
import { ExportService, ExportRequest } from '../../services/export.service';

export interface ExportDialogData {
    title: string;
    type: 'facility' | 'performer';
    referral_group_id?: string;
    search_term?: string;
    search_type?: string;
}

@Component({
    selector: 'app-export-dialog',
    templateUrl: './export-dialog.component.html',
    styleUrls: ['./export-dialog.component.scss'],
    standalone: false
})
export class ExportDialogComponent implements OnInit {
    exportForm: UntypedFormGroup;
    isProcessing = false;

    emails: string[] = [];
    readonly separatorKeysCodes = [ENTER, COMMA] as const;

    constructor(
        private fb: UntypedFormBuilder,
        private dialogRef: MatDialogRef<ExportDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ExportDialogData,
        private alertService: AlertService,
        private exportService: ExportService
    ) {
        this.createForm();
    }

    ngOnInit(): void {
    }

    private createForm(): void {
        this.exportForm = this.fb.group({
            emailInput: ['']
        });
    }

    addEmail(event: MatChipInputEvent): void {
        const value = (event.value || '').trim();

        if (value) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (emailRegex.test(value) && !this.emails.includes(value)) {
                this.emails.push(value);
            }
        }

        event.chipInput!.clear();
        this.exportForm.get('emailInput')?.setValue('');
    }

    removeEmail(email: string): void {
        const index = this.emails.indexOf(email);
        if (index >= 0) {
            this.emails.splice(index, 1);
        }
    }

    get emailsEmpty(): boolean {
        return this.emails.length === 0;
    }

    get hasInvalidEmails(): boolean {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return this.emails.some(email => !emailRegex.test(email));
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onExport(): void {
        if (!this.emailsEmpty && !this.hasInvalidEmails && !this.isProcessing) {
            this.isProcessing = true;

            const exportRequest: ExportRequest = {
                export: 1,
                type: this.data.type,
                format: 'csv',
                emailAddresses: this.emails.join(','),
                referral_group_id: this.data.referral_group_id,
                search_term: this.data.search_term,
                search_type: this.data.search_type
            };

            Object.keys(exportRequest).forEach(key => {
                if (exportRequest[key] === undefined || exportRequest[key] === '') {
                    delete exportRequest[key];
                }
            });


            this.exportService.exportData(exportRequest).subscribe({
                next: (response) => {
                    this.isProcessing = false;
                    this.alertService.notifySuccess(`Export request submitted successfully! Your ${this.data.type} data will be emailed shortly.`);
                    this.dialogRef.close(response);
                },
                error: (error) => {
                    this.isProcessing = false;
                    this.alertService.notifyError('Export request failed. Please check your connection and try again.');
                    console.error('Export error:', error);
                }
            });
        }
    }
}
